var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-col",
    { attrs: { md: "12", lg: "6" } },
    [
      _c(
        "v-alert",
        {
          attrs: {
            prominent: "",
            dark: "",
            border: "left",
            color: "deep-purple darken-4",
            icon: "mdi-atom-variant"
          }
        },
        [
          _c("div", { staticClass: "heading h2" }, [
            _vm._v("\n      " + _vm._s(_vm.info.name) + "\n    ")
          ]),
          _vm._v(" "),
          _vm.info.website || _vm.info.twitter || _vm.info.github
            ? _c(
                "div",
                { staticClass: "mt-1 mb-n3" },
                [
                  _vm.info.website
                    ? _c(
                        "v-btn",
                        {
                          attrs: {
                            target: "_blank",
                            href: "" + _vm.info.website,
                            icon: ""
                          }
                        },
                        [
                          _c("v-icon", { attrs: { color: "cyan lighten-2" } }, [
                            _vm._v("mdi-web")
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.info.twitter
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "mb-n2",
                          attrs: {
                            target: "_blank",
                            href: "https://twitter.com/" + _vm.info.twitter,
                            icon: ""
                          }
                        },
                        [
                          _c("v-icon", { attrs: { color: "cyan lighten-2" } }, [
                            _vm._v("mdi-twitter")
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.info.github
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "mb-n2",
                          attrs: {
                            target: "_blank",
                            href: "https://github.com/" + _vm.info.github,
                            icon: ""
                          }
                        },
                        [
                          _c("v-icon", { attrs: { color: "cyan lighten-2" } }, [
                            _vm._v("mdi-github-circle")
                          ])
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }